import { useQuery } from 'hooks/useCustomQuery';
import getTCAPUserByID from '@/API/TCAPUser/getTCAPUserByID';

const useGetTCAPUserByID = (TCAPUserId, setPrimaryUser) => {
    return useQuery({
        queryKey: ['TCAPPlatformUsers', TCAPUserId],
        queryFn: async () => {
            if (!TCAPUserId) {
                return Promise.reject(new Error('Invalid TCAPUserId'));
            }
            const data = await getTCAPUserByID(TCAPUserId);

            const primaryUserId = data?.primaryUser?.id;
            const orderedData = data.platformUsers.slice().sort((a, b) => {
                if (a.id === primaryUserId) return -1;
                if (b.id === primaryUserId) return 1;
                return a.displayName.localeCompare(b.displayName);
            });
            setPrimaryUser(data?.primaryUser);
            return orderedData;
        },
        enabled: Boolean(TCAPUserId),
        refetchOnWindowFocus: false,
        staleTime: 0,
        retry: false,
    });
};

export default useGetTCAPUserByID;
